import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { cuesApi } from "./imports";
import CueEditTheme from "./shared/CueEditTheme";

export default function CueEditThemeWrapper({ cue }) {
	const { projectId } = useParams();

	const selectedTheme = useSelector(
		(state) => state.main.projects[projectId]?.theme
	);
	const themes = useSelector(
		(state) => state.main?.projects?.[projectId].themes
	);

	const handleOnUpdate = (update) => {
		cuesApi.updateCue(cue.id, projectId, update);
	};

	return (
		<CueEditTheme
			cue={cue}
			onUpdate={handleOnUpdate}
			themes={themes}
			selectedTheme={selectedTheme}
		/>
	);
}
